import {
  formatNumberNDecimalPlaces,
  formatBytes,
  capitalizeString
} from "../../../utils/format";
import { getColor } from "../../../utils/colors";
import { defaultCellValue } from "../../../utils/enums";
import {
  getCellTemplateWithTooltip,
} from "../../../utils/table";

export const getTableColumns = (tableId, tViews=()=>{}) => {
  let tableColumns = [
    {
      prop: "user_ip",
      name: tViews('clientIpColHeader'),
      sortable: true,
      size: 150
    },
    {
      prop: "site_id",
      name: tViews('allSiteSiteLabel'),
      sortable: true,
      size: 120
    },
    {
      prop: "city",
      name: tViews('circuit.ctLocation'),
      size: 170,
      cellProperties: () => {
        return { role: "cell" };
      },
      cellTemplate: (...args) => getCellTemplateWithTooltip(tableId, ...args),
    }, 
    {
      prop: "vqoe",
      name: tViews('allSiteQoELabel'),
      size: 140,
      cellProperties: ({ model, prop }) => {
        return { style: { color: getColor(model[prop], "qoe") } };
      }
    },
    {
      prop: "usage",
      name: tViews('allSiteUsageLabel'),
      sortable: true,
      size: 150
    },
    {
      prop: "loss",
      name: tViews('app360.afHeatMapLoss'),
      size: 150
    },
    {
      prop: "latency",
      name: tViews('app360.afHeatMapLatency'),
      size: 170
    },
    {
      prop: "jitter",
      name: tViews('app360Jitter'),
      size: 150
    },
  ];
  return tableColumns.map(col => ({
    ...col,
    id: col.prop,
    sortable: col.prop !== "actions" ? true : false
  }));
};
const validateAndFormatNumber = (value, decimalPlaces = 1) => {
  if (Number.isFinite(value)){
    return formatNumberNDecimalPlaces(value, decimalPlaces);
  }
  return defaultCellValue;
};
export const setTopUserData = data => {
  if (!Array.isArray(data)) return [];

  return data.map(item => ({
    ...item,
    availability: validateAndFormatNumber(item.availability),
    city: capitalizeString(item.city),
    packet_loss: validateAndFormatNumber(item.packet_loss),
    latency: validateAndFormatNumber(item.latency),
    jitter: validateAndFormatNumber(item.jitter),
    usage: formatBytes(item.usage)
  }));
};

export const formatUsageCellData = (value) =>{
  const newCellData = formatBytes(value);
  return newCellData;
}